export default __webpack_public_path__ + "static/media/white_common_king.50452091.png";